export const cookiesTranslations = {
  es: {
    'page-title': 'Política de Cookies - BlueCMR',
    'page-description': 'Información sobre el uso de cookies en el sitio web de BlueCMR S.L.U.',
    'title': 'Política de Cookies',
    'last-updated': 'Versión: v1.1 - Enero 2026',

    // Section 1 - Introducción
    'section-1-title': '1. Introducción',
    'section-1-p1': 'Esta Política de Cookies (en adelante, "LA POLÍTICA") es parte integrante del Aviso Legal y la Política de Privacidad del sitio web https://bluecmr.com/ (en adelante, el "SITIO WEB").',
    'section-1-p2': 'Con el objetivo de garantizar tu privacidad, te informamos que en la web de BlueCMR S.L.U. utilizamos cookies y otros mecanismos similares que nos permiten facilitarte el uso y navegación a través de la página web, garantizar el acceso a determinadas funcionalidades y adicionalmente, nos ayudan a mejorar la calidad de la página de acuerdo a tus hábitos y estilos de navegación.',

    // Section 2 - Responsable
    'section-2-title': '2. Responsable del Uso de Cookies',
    'section-2-p1': 'El responsable del uso de cookies en este sitio web es:',
    'section-2-company': 'Denominación social: BlueCMR S.L.U.',
    'section-2-cif': 'CIF: B26654517',
    'section-2-address': 'Domicilio social: Calle Fueros de Leon 1, 24402, Ponferrada, León, España',
    'section-2-email': 'Email de contacto: support@bluecmr.com',

    // Section 3 - Qué son las cookies
    'section-3-title': '3. ¿Qué son las Cookies?',
    'section-3-p1': 'Una cookie es un fichero que se descarga en tu terminal (ordenador, smartphone, tableta u otro dispositivo) cuando accedes a una página web y que permite al titular de dicha página almacenar o recuperar determinada información, como el número de visitas, identificar al usuario registrado, garantizar la sesión, etc.',
    'section-3-p2': 'Las cookies ofrecen información sobre los hábitos de navegación de los usuarios y pueden afectar a su privacidad. Por este motivo, queremos ofrecerte la información necesaria sobre las cookies utilizadas en nuestra web para que tengas plena capacidad de decisión.',

    // Section 4 - Tipos de cookies
    'section-4-title': '4. Tipos de Cookies Utilizadas',
    'section-4-p1': 'Las cookies utilizadas en este sitio web se clasifican según su finalidad:',
    'section-4-technical-title': 'Cookies Técnicas',
    'section-4-technical-desc': 'Son estrictamente necesarias para la navegación y el funcionamiento del sitio web. Sin ellas, las funciones básicas quedarían inhabilitadas.',
    'section-4-analytics-title': 'Cookies Analíticas',
    'section-4-analytics-desc': 'Permiten el seguimiento y análisis del comportamiento de los usuarios del sitio web. La información recogida se utiliza para medir la actividad del sitio y elaborar perfiles de navegación con el objetivo de introducir mejoras.',
    'section-4-marketing-title': 'Cookies de Marketing',
    'section-4-marketing-desc': 'Permiten la gestión de los espacios publicitarios y almacenan información del comportamiento del usuario para mostrar publicidad personalizada.',

    // Section 5 - Cookie table
    'section-5-title': '5. Detalle de Cookies Utilizadas',
    'section-5-p1': 'A continuación se detallan las cookies utilizadas en el sitio web:',
    'table-name': 'Cookie',
    'table-type': 'Tipo',
    'table-purpose': 'Finalidad',
    'table-duration': 'Duración',
    'table-owner': 'Titularidad',

    // Cookie entries
    'cookie-session-name': 'session_id',
    'cookie-session-type': 'Técnica',
    'cookie-session-purpose': 'Mantener la sesión del usuario durante la navegación.',
    'cookie-session-duration': 'Sesión',
    'cookie-session-owner': 'bluecmr.com',

    'cookie-csrf-name': 'csrf_token',
    'cookie-csrf-type': 'Técnica',
    'cookie-csrf-purpose': 'Prevenir ataques CSRF (Cross-Site Request Forgery) para garantizar la seguridad.',
    'cookie-csrf-duration': 'Sesión',
    'cookie-csrf-owner': 'bluecmr.com',

    'cookie-consent-name': 'cookie_consent',
    'cookie-consent-type': 'Técnica',
    'cookie-consent-purpose': 'Almacenar las preferencias de cookies del usuario.',
    'cookie-consent-duration': '1 año',
    'cookie-consent-owner': 'bluecmr.com',

    'cookie-lang-name': 'i18next',
    'cookie-lang-type': 'Técnica',
    'cookie-lang-purpose': 'Recordar el idioma seleccionado por el usuario.',
    'cookie-lang-duration': '1 año',
    'cookie-lang-owner': 'bluecmr.com',

    'cookie-ga-name': '_ga',
    'cookie-ga-type': 'Analítica',
    'cookie-ga-purpose': 'Distinguir usuarios únicos asignando un identificador generado aleatoriamente (Google Analytics).',
    'cookie-ga-duration': '2 años',
    'cookie-ga-owner': 'Google',

    'cookie-gid-name': '_gid',
    'cookie-gid-type': 'Analítica',
    'cookie-gid-purpose': 'Distinguir usuarios y almacenar información sobre la sesión de navegación (Google Analytics).',
    'cookie-gid-duration': '24 horas',
    'cookie-gid-owner': 'Google',

    'cookie-gat-name': '_gat',
    'cookie-gat-type': 'Analítica',
    'cookie-gat-purpose': 'Limitar el porcentaje de solicitudes a Google Analytics.',
    'cookie-gat-duration': '1 minuto',
    'cookie-gat-owner': 'Google',

    // Section 6 - Cómo desactivar cookies
    'section-6-title': '6. Cómo Desactivar las Cookies',
    'section-6-p1': 'Puedes aceptar, rechazar o configurar el uso de cookies no esenciales a través del panel de configuración de cookies, accesible en todo momento desde el enlace visible en la parte inferior del sitio web.',
    'section-6-p2': 'Además, puedes configurar tu navegador para permitir o rechazar cookies. A continuación se indican los enlaces de configuración de los navegadores más utilizados:',
    'section-6-chrome': 'Google Chrome',
    'section-6-firefox': 'Mozilla Firefox',
    'section-6-edge': 'Microsoft Edge',
    'section-6-safari': 'Safari',
    'section-6-p3': 'Ten en cuenta que, si se impide la instalación de todas las cookies, algunas funcionalidades del sitio web pueden verse afectadas.',

    // Section 7 - Terceros
    'section-7-title': '7. Cookies de Terceros',
    'section-7-p1': 'BlueCMR S.L.U. utiliza servicios de terceros que pueden instalar cookies en función del consentimiento prestado por el usuario. En particular, proveedores como Google LLC podrían tratar los datos recabados a través de sus cookies desde fuera del Espacio Económico Europeo (EEE), conforme a sus propias políticas de privacidad.',
    'section-7-p2': 'Puedes consultar la política de privacidad de Google en:',

    // Section 8 - Conservación
    'section-8-title': '8. Periodo de Conservación',
    'section-8-p1': 'Los datos recabados a través de las cookies se conservarán mientras sean necesarios para la finalidad para la cual son tratados. Posteriormente, se conservarán bloqueados a disposición de la Administración de Justicia durante los plazos legalmente establecidos.',

    // Section 9 - Actualizaciones
    'section-9-title': '9. Actualizaciones de esta Política',
    'section-9-p1': 'BlueCMR S.L.U. podrá modificar esta Política de Cookies para adaptarla a exigencias legislativas o reglamentarias. Te aconsejamos la visita periódica a su contenido.',

    // Footer
    'footer-copyright': '© 2026 BlueCMR S.L.U. Todos los derechos reservados.',
    'footer-contact': 'Para cualquier consulta sobre esta política, contacta con nosotros en:',
    'footer-email': 'support@bluecmr.com',
  },

  en: {
    'page-title': 'Cookie Policy - BlueCMR',
    'page-description': 'Information about the use of cookies on the BlueCMR S.L.U. website.',
    'title': 'Cookie Policy',
    'last-updated': 'Version: v1.1 - January 2026',

    // Section 1 - Introduction
    'section-1-title': '1. Introduction',
    'section-1-p1': 'This Cookie Policy (hereinafter, "THE POLICY") is an integral part of the Legal Notice and Privacy Policy of the website https://bluecmr.com/ (hereinafter, the "WEBSITE").',
    'section-1-p2': 'To guarantee your privacy, we inform you that BlueCMR S.L.U. uses cookies and similar mechanisms on our website to facilitate your use and navigation, ensure access to certain functionalities, and help us improve the quality of the website according to your browsing habits.',

    // Section 2 - Responsible entity
    'section-2-title': '2. Responsible for Cookie Usage',
    'section-2-p1': 'The entity responsible for the use of cookies on this website is:',
    'section-2-company': 'Company name: BlueCMR S.L.U.',
    'section-2-cif': 'Tax ID (CIF): B26654517',
    'section-2-address': 'Registered office: Calle Fueros de Leon 1, 24402, Ponferrada, León, Spain',
    'section-2-email': 'Contact email: support@bluecmr.com',

    // Section 3 - What are cookies
    'section-3-title': '3. What are Cookies?',
    'section-3-p1': 'A cookie is a file that is downloaded to your device (computer, smartphone, tablet, or other device) when you access a website, allowing the website owner to store or retrieve certain information, such as the number of visits, identify registered users, ensure the session, etc.',
    'section-3-p2': 'Cookies provide information about users\' browsing habits and may affect their privacy. For this reason, we want to provide you with the necessary information about the cookies used on our website so that you can make informed decisions.',

    // Section 4 - Types of cookies
    'section-4-title': '4. Types of Cookies Used',
    'section-4-p1': 'The cookies used on this website are classified according to their purpose:',
    'section-4-technical-title': 'Technical Cookies',
    'section-4-technical-desc': 'Strictly necessary for navigation and the functioning of the website. Without them, basic functions would be disabled.',
    'section-4-analytics-title': 'Analytics Cookies',
    'section-4-analytics-desc': 'Allow tracking and analysis of user behavior on the website. The information collected is used to measure website activity and create browsing profiles to introduce improvements.',
    'section-4-marketing-title': 'Marketing Cookies',
    'section-4-marketing-desc': 'Allow the management of advertising spaces and store user behavior information to display personalized advertising.',

    // Section 5 - Cookie table
    'section-5-title': '5. Detailed Cookie List',
    'section-5-p1': 'Below is a detailed list of the cookies used on this website:',
    'table-name': 'Cookie',
    'table-type': 'Type',
    'table-purpose': 'Purpose',
    'table-duration': 'Duration',
    'table-owner': 'Owner',

    // Cookie entries
    'cookie-session-name': 'session_id',
    'cookie-session-type': 'Technical',
    'cookie-session-purpose': 'Maintain the user session during navigation.',
    'cookie-session-duration': 'Session',
    'cookie-session-owner': 'bluecmr.com',

    'cookie-csrf-name': 'csrf_token',
    'cookie-csrf-type': 'Technical',
    'cookie-csrf-purpose': 'Prevent CSRF (Cross-Site Request Forgery) attacks to ensure security.',
    'cookie-csrf-duration': 'Session',
    'cookie-csrf-owner': 'bluecmr.com',

    'cookie-consent-name': 'cookie_consent',
    'cookie-consent-type': 'Technical',
    'cookie-consent-purpose': 'Store the user\'s cookie preferences.',
    'cookie-consent-duration': '1 year',
    'cookie-consent-owner': 'bluecmr.com',

    'cookie-lang-name': 'i18next',
    'cookie-lang-type': 'Technical',
    'cookie-lang-purpose': 'Remember the language selected by the user.',
    'cookie-lang-duration': '1 year',
    'cookie-lang-owner': 'bluecmr.com',

    'cookie-ga-name': '_ga',
    'cookie-ga-type': 'Analytics',
    'cookie-ga-purpose': 'Distinguish unique users by assigning a randomly generated identifier (Google Analytics).',
    'cookie-ga-duration': '2 years',
    'cookie-ga-owner': 'Google',

    'cookie-gid-name': '_gid',
    'cookie-gid-type': 'Analytics',
    'cookie-gid-purpose': 'Distinguish users and store browsing session information (Google Analytics).',
    'cookie-gid-duration': '24 hours',
    'cookie-gid-owner': 'Google',

    'cookie-gat-name': '_gat',
    'cookie-gat-type': 'Analytics',
    'cookie-gat-purpose': 'Limit the request rate to Google Analytics.',
    'cookie-gat-duration': '1 minute',
    'cookie-gat-owner': 'Google',

    // Section 6 - How to disable cookies
    'section-6-title': '6. How to Disable Cookies',
    'section-6-p1': 'You can accept, reject, or configure the use of non-essential cookies through the cookie settings panel, accessible at any time from the link visible at the bottom of the website.',
    'section-6-p2': 'Additionally, you can configure your browser to allow or reject cookies. Below are the configuration links for the most commonly used browsers:',
    'section-6-chrome': 'Google Chrome',
    'section-6-firefox': 'Mozilla Firefox',
    'section-6-edge': 'Microsoft Edge',
    'section-6-safari': 'Safari',
    'section-6-p3': 'Please note that if all cookies are blocked, some website functionalities may be affected.',

    // Section 7 - Third parties
    'section-7-title': '7. Third-Party Cookies',
    'section-7-p1': 'BlueCMR S.L.U. uses third-party services that may install cookies based on the consent given by the user. In particular, providers such as Google LLC may process data collected through their cookies from outside the European Economic Area (EEA), in accordance with their own privacy policies.',
    'section-7-p2': 'You can consult Google\'s privacy policy at:',

    // Section 8 - Retention
    'section-8-title': '8. Retention Period',
    'section-8-p1': 'Data collected through cookies will be retained for as long as necessary for the purpose for which they are processed. Subsequently, they will be kept blocked and available to the courts for the legally established periods.',

    // Section 9 - Updates
    'section-9-title': '9. Updates to this Policy',
    'section-9-p1': 'BlueCMR S.L.U. may modify this Cookie Policy to adapt it to legislative or regulatory requirements. We recommend that you periodically review its content.',

    // Footer
    'footer-copyright': '© 2026 BlueCMR S.L.U. All rights reserved.',
    'footer-contact': 'For any questions about this policy, contact us at:',
    'footer-email': 'support@bluecmr.com',
  },
};
